module.exports = __webpack_public_path__ + "img/pic_ridex@2x.f40eb535.png";